import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPropertiesStart } from './store/slices/propertiesSlice';
import { checkAuth } from './store/slices/authSlice';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import PropertiesPage from './pages/PropertiesPage';
import PropertyDetailsPage from './pages/PropertyDetailsPage';
import MapPage from './pages/MapPage';
import AgentsPage from './pages/AgentsPage';
import AgentDetailsPage from './pages/AgentDetailsPage';
import AgentApplyPage from './pages/AgentApplyPage';
import AboutUsPage from './pages/AboutUsPage';
import OfficesPage from './pages/OfficesPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminRegisterPage from './pages/AdminRegisterPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.ui);
  const location = useLocation();

  useEffect(() => {
    // Check authentication on app load (will trigger saga to verify token)
    dispatch(checkAuth());
    // Fetch properties using Redux Saga
    dispatch(fetchPropertiesStart());
  }, [dispatch]);

  useEffect(() => {
    // Apply theme to body
    document.body.className = theme;
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const hideSiteChrome =
    location.pathname.startsWith('/admin/login') ||
    location.pathname.startsWith('/admin/register');

  return (
    <div className="App">
      {!hideSiteChrome && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/property/:id" element={<PropertyDetailsPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/apply" element={<AgentApplyPage />} />
          <Route path="/offices" element={<OfficesPage />} />
          <Route path="/team" element={<Navigate to="/agents" replace />} />
          <Route path="/agent/:id" element={<AgentDetailsPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/register"
            element={
              <ProtectedRoute>
                <AdminRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!hideSiteChrome && <Footer />}
    </div>
  );
}

export default App;
